module.exports = __webpack_public_path__ + "static/media/mobile834.c5789c4e.png";